export default __webpack_public_path__ + "static/media/gallery_22.4a51d95a.jpg";